import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import MyAccountMenu from "./MyAccountMenu";
import { getToken } from "../services/LocalStorageSrv";
import { Helmet } from "react-helmet";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import Loader from "../Loader";
import { ToastContainer } from "react-toastify";

const Invoice = () => {
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const location = useLocation();
  const apiUrl = process.env.REACT_APP_API_URL;
  const nvg = useNavigate();
  const localdata = getToken("data");
  const [loading, setLoading] = useState(false);
  const [Tabcontent, setTab] = useState("Outstanding Invoices");

  // Separate state for each tab
  const [allInvoices, setAllInvoices] = useState([]); // ALL invoices from GetInvoiceDetailsNew
  const [allOutstandingInvoices, setAllOutstandingInvoices] = useState([]); // From GetOutstandingInvoicesNew

  const [filteredData1, setFilteredData1] = useState([]); // all invoices
  const [filteredData2, setFilteredData2] = useState([]); // outstanding only

  const [date1, setdate1] = useState(new Date());
  const [date2, setdate2] = useState(new Date("2025-01-01"));

  const [allInvoiceSum, setAllInvoiceSum] = useState(0);
  const [allOutstandingInvoiceSum, setAllOutstandingInvoiceSum] = useState(0);

  function apiformatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
  }

  const searchDateWise = async () => {
    const fromD = apiformatDate(date2);
    const toD = apiformatDate(date1);

    // Reset pagination to page 1
    setCurrentPage1(1);
    setCurrentPage2(1);

    fetchInvoicesData(fromD, toD);
  };

  const fetchInvoicesData = async (fromD, toD) => {
    setLoading(true);
    try {
      console.log("Fetching invoice data...");
      console.log("Date Range:", fromD, "to", toD);

      // ==========================
      // 1️⃣ Call GetInvoiceDetailsNew API (for ALL Invoices)
      // ==========================
      const invoiceDetailsResponse = await axios.get(
        `${apiUrl}/GetInvoiceDetailsNew?CustomerCode=${localdata.data.vendor_code}&FromDate=${fromD}&ToDate=${toD}`,
        {
          headers: {
            Authorization: `Bearer ${localdata.data.token}`,
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
          },
        },
      );

      console.log("Invoice Details API Response:", invoiceDetailsResponse.data);

      // ==========================
      // 2️⃣ Call GetOutstandingInvoicesNew API (for Outstanding summary)
      // ==========================
      const outstandingResponse = await axios.get(
        `${apiUrl}/GetOutstandingInvoicesNew?CustomerCode=${localdata.data.vendor_code}`,
        {
          headers: {
            Authorization: `Bearer ${localdata.data.token}`,
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
          },
        },
      );

      console.log("Outstanding API Response:", outstandingResponse.data);

      // ==========================
      // 3️⃣ Process ALL Invoices from GetInvoiceDetailsNew
      // ==========================
      const invoiceDetailsData = invoiceDetailsResponse.data;
      const outstandingData = outstandingResponse.data;

      // Create a map of outstanding invoice numbers for quick lookup
      const outstandingInvoiceNumbers = new Set();
      outstandingData.forEach((item) => {
        if (item.Memo && item.Memo.includes("A/R Invoices")) {
          outstandingInvoiceNumbers.add(String(item.BaseRef));
        }
      });

      console.log(
        "Outstanding invoice numbers:",
        Array.from(outstandingInvoiceNumbers),
      );

      let allInvoicesList = [];
      let totalAllInvoicesAED = 0;

      // Process all transactions from GetInvoiceDetailsNew
      invoiceDetailsData.forEach((item) => {
        const transType = item.TransType;
        const invoiceNum = String(item.DocNum);
        let status = "";
        let displayAmount = item.Debit || 0;
        let isInvoiceRecord = false;

        // Determine status based on TransType
        if (transType === "A/R Invoice") {
          // This is an invoice
          isInvoiceRecord = true;

          // Check if it's in outstanding list
          const isOutstanding = outstandingInvoiceNumbers.has(invoiceNum);

          if (isOutstanding) {
            status = "Outstanding";
          } else {
            status = "Paid";
          }
        } else if (transType === "Incoming Payment") {
          // This is a payment - mark as paid
          isInvoiceRecord = true;
          status = "Paid";
        } else if (transType === "A/R Credit Memo") {
          // This is a credit memo (refund to customer)
          isInvoiceRecord = true;
          status = "Credit Memo";
          displayAmount = Math.abs(item.Debit || 0); // Show as positive for display
        }

        // Only add invoice-related records (not other transaction types)
        if (isInvoiceRecord) {
          const invoiceWithStatus = {
            ...item,
            Debit: displayAmount,
            isPaid: status === "Paid",
            paymentStatus: status,
            isCredit: transType === "A/R Credit Memo",
          };

          allInvoicesList.push(invoiceWithStatus);

          // Add to total (credit memos are negative in calculation)
          if (transType === "A/R Credit Memo") {
            totalAllInvoicesAED -= displayAmount;
          } else {
            totalAllInvoicesAED += displayAmount;
          }
        }
      });

      console.log("Total invoices found:", allInvoicesList.length);
      console.log("Total All Invoices AED:", totalAllInvoicesAED);

      setAllInvoiceSum(totalAllInvoicesAED);

      // Sort by DocDate descending (latest first)
      allInvoicesList.sort((a, b) => new Date(b.DocDate) - new Date(a.DocDate));

      setAllInvoices(allInvoicesList);
      setFilteredData1(allInvoicesList);

      // ==========================
      // 4️⃣ Process Outstanding Data (from Outstanding API)
      // ==========================
      let outstandingInvoices = [];
      let totalOutstandingAED = 0;

      outstandingData.forEach((item) => {
        // Only show A/R Invoices (not payments or credit memos)
        if (
          item.Memo &&
          (item.Memo.includes("A/R Invoices") ||
            item.Memo.includes("Incoming Payments"))
        ) {
          outstandingInvoices.push({
            DocNum: item.BaseRef,
            DocDate: item.RefDate,
            Debit: item.DueAmt, // ⚠️ keep negative as-is
            ShortName: item.ShortName,
            CardName: item.CardName,
            DueDate: item.DueDate,
            DueDays: item.DueDays,
            TransType: item.DueAmt < 0 ? "Incoming Payment" : "A/R Invoice",
            CreatedBy: item.CNO,
            isPaid: false,
            paymentStatus: item.DueAmt < 0 ? "Credit" : "Outstanding",
            isCredit: item.DueAmt < 0,
          });
          totalOutstandingAED += item.DueAmt || 0;
        }
      });

      console.log("Outstanding invoices found:", outstandingInvoices.length);
      console.log("Total Outstanding AED:", totalOutstandingAED);

      setAllOutstandingInvoiceSum(totalOutstandingAED);

      // Sort by DocDate descending
      outstandingInvoices.sort(
        (a, b) => new Date(b.DocDate) - new Date(a.DocDate),
      );

      setAllOutstandingInvoices(outstandingInvoices);
      setFilteredData2(outstandingInvoices);

      // Reset search queries
      setSearchQuery1("");
      setSearchQuery2("");

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Error loading invoice data. Please try again.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.pathname === "/invoice/cancel") {
      alert("Payment Failed");
      setTimeout(() => nvg("/invoice"), 0);
    } else if (location.pathname === "/invoice/success") {
      alert("Payment Success");
      setTimeout(() => nvg("/invoice"), 0);
    }
  }, [location.pathname, nvg]);

  useEffect(() => {
    const fromD = apiformatDate(date2);
    const toD = apiformatDate(date1);
    fetchInvoicesData(fromD, toD);
  }, []);

  // Pagination for All Invoices
  const pageSize1 = 15;
  const [currentPage1, setCurrentPage1] = useState(1);
  const [searchQuery1, setSearchQuery1] = useState("");
  const [sortedField1, setSortedField1] = useState("");
  const [sortDirection1, setSortDirection1] = useState("asc");

  const handleSearchInputChange1 = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery1(query);
    setCurrentPage1(1);

    const filtered = allInvoices.filter((item) => {
      const docNum = String(item.DocNum);
      return docNum.toLowerCase().includes(query);
    });
    setFilteredData1(filtered);
  };

  const handleSort1 = (field) => {
    if (field === sortedField1) {
      setSortDirection1(sortDirection1 === "asc" ? "desc" : "asc");
    } else {
      setSortedField1(field);
      setSortDirection1("asc");
    }
  };

  const totalPages1 = Math.ceil(filteredData1.length / pageSize1);
  const startIndex1 = (currentPage1 - 1) * pageSize1;
  const endIndex1 = Math.min(startIndex1 + pageSize1, filteredData1.length);

  const sortedData1 = [...filteredData1].sort((a, b) => {
    if (!sortedField1) return 0;

    const aVal = a[sortedField1];
    const bVal = b[sortedField1];

    if (typeof aVal === "string" && typeof bVal === "string") {
      return sortDirection1 === "asc"
        ? aVal.localeCompare(bVal)
        : bVal.localeCompare(aVal);
    }
    return 0;
  });

  const currentPageData1 = sortedData1.slice(startIndex1, endIndex1);

  // Pagination for Outstanding Invoices
  const pageSize2 = 15;
  const [currentPage2, setCurrentPage2] = useState(1);
  const [searchQuery2, setSearchQuery2] = useState("");
  const [sortedField2, setSortedField2] = useState("");
  const [sortDirection2, setSortDirection2] = useState("asc");

  const handleSearchInputChange2 = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery2(query);
    setCurrentPage2(1);

    const filtered = allOutstandingInvoices.filter((item) => {
      const docNum = String(item.DocNum);
      return docNum.toLowerCase().includes(query);
    });
    setFilteredData2(filtered);
  };

  const handleSort2 = (field) => {
    if (field === sortedField2) {
      setSortDirection2(sortDirection2 === "asc" ? "desc" : "asc");
    } else {
      setSortedField2(field);
      setSortDirection2("asc");
    }
  };

  const totalPages2 = Math.ceil(filteredData2.length / pageSize2);
  const startIndex2 = (currentPage2 - 1) * pageSize2;
  const endIndex2 = Math.min(startIndex2 + pageSize2, filteredData2.length);

  const sortedData2 = [...filteredData2].sort((a, b) => {
    if (!sortedField2) return 0;

    const aVal = a[sortedField2];
    const bVal = b[sortedField2];

    if (typeof aVal === "string" && typeof bVal === "string") {
      return sortDirection2 === "asc"
        ? aVal.localeCompare(bVal)
        : bVal.localeCompare(aVal);
    }
    return 0;
  });

  const currentPageData2 = sortedData2.slice(startIndex2, endIndex2);

  const changeFormatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const changeFilterFormatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const [inputValue, setInputValue] = useState("0.00");
  const [selectAll, setSelectAll] = useState(false);

  const handleInvoiceCheckboxChange = (invoice, event) => {
    const checked = event.target.checked;
    if (checked) {
      setSelectedInvoices((prev) => [...prev, invoice]);
    } else {
      setSelectedInvoices((prev) =>
        prev.filter((inv) => inv.DocNum !== invoice.DocNum),
      );
      setSelectAll(false);
    }
  };

  const handleSelectAllChange = () => {
    if (!selectAll) {
      setSelectedInvoices([...currentPageData2]);
    } else {
      setSelectedInvoices([]);
    }
    setSelectAll(!selectAll);
  };

  const calculateTotalAmount = () => {
    return selectedInvoices
      .reduce((total, invoice) => total + parseFloat(invoice.Debit || 0), 0)
      .toFixed(2);
  };

  useEffect(() => {
    setInputValue(calculateTotalAmount());
  }, [selectedInvoices]);

  const handleSingleInvoicePayment = async (invoice_info) => {
    const roundedAmount = parseFloat(invoice_info.Debit.toFixed(2));
    const userConfirmed = window.confirm(
      `You are about to pay AED ${roundedAmount}. Do you want to proceed?`,
    );

    if (!userConfirmed) return;

    const requestData = {
      invoiceid: invoice_info.DocNum,
      user_id: localdata.data.id,
      BpCode: invoice_info.ShortName,
      invoicelink: invoice_info.CreatedBy,
      invoicestatus: "O",
      payment_method: 2,
      payable_amount: invoice_info.Debit,
      vat_cost: 0,
      discount: 0,
      total_amount: invoice_info.Debit,
    };

    setLoading(true);

    try {
      const response = await axios.post(
        `${apiUrl}/paySingleInvoice`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${localdata.data.token}`,
          },
        },
      );

      if (response.status === 200 && response.data.Transaction.PaymentPortal) {
        window.location.replace(response.data.Transaction.PaymentPortal);
      } else {
        alert("Payment gateway link not found.");
      }
    } catch (error) {
      console.error("Payment error:", error);
      alert("An error occurred during payment initiation.");
    } finally {
      setLoading(false);
    }
  };

  const handleMultipleInvoicePayment = async () => {
    if (selectedInvoices.length < 1) {
      alert("Select at least one invoice for payment");
      return;
    }

    const totalAmount = selectedInvoices.reduce(
      (sum, inv) => sum + inv.Debit,
      0,
    );

    if (totalAmount <= 0) {
      alert("Total amount is zero or negative. No payment required.");
      return;
    }

    const roundedAmount = parseFloat(totalAmount.toFixed(2));

    const userConfirmed = window.confirm(
      `You are about to pay AED ${roundedAmount} for ${selectedInvoices.length} invoice(s). Do you want to proceed?`,
    );

    if (!userConfirmed) return;

    const requestData = selectedInvoices.map((invoice) => ({
      invoiceid: invoice.DocNum,
      user_id: localdata.data.id,
      BpCode: invoice.ShortName,
      invoicelink: invoice.CreatedBy,
      invoicestatus: "O",
      payment_method: 2,
      payable_amount: invoice.Debit,
      vat_cost: 0,
      discount: 0,
      total_amount: invoice.Debit,
    }));

    setLoading(true);

    try {
      const response = await axios.post(
        `${apiUrl}/payMultipleInvoice`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${localdata.data.token}`,
          },
        },
      );

      if (response.status === 200 && response.data.Transaction.PaymentPortal) {
        window.location.replace(response.data.Transaction.PaymentPortal);
      } else {
        alert("Payment gateway link not found.");
      }
    } catch (error) {
      console.error("Payment error:", error);
      alert("An error occurred during payment initiation.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ToastContainer />
      {loading && <Loader />}
      <Helmet>
        <title>Invoices | Vaultex</title>
      </Helmet>

      <section id="product-listing-sec" className="inner-page-bg mb-5">
        <div className="container">
          <div className="row">
            <MyAccountMenu />

            <div
              className="col-lg-9 col-sm-12 Myitems-box"
              style={{ alignSelf: "flex-start", marginTop: "18px" }}
            >
              <div className="row">
                <h2 className="myItems">Invoices</h2>
              </div>

              {/* Date Filter */}
              <div className="row datepicker">
                <div className="col-5">
                  <div className="fromdate">
                    <label style={{ lineHeight: "41px" }}>From date:</label>
                    <div
                      className="b-form-btn-label-control dropdown b-form-datepicker form-control"
                      style={{
                        display: "flex",
                        alignItems: "stretch",
                        height: "auto",
                        padding: "0",
                        backgroundImage: "none",
                      }}
                    >
                      <DatePicker
                        id="clickdatepic1"
                        selected={date2}
                        onChange={(date) => setdate2(date)}
                        dateFormat="yyyy-MM-dd"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        customInput={
                          <button
                            type="button"
                            className="btn h-auto react-datepicker-ignore-onclickoutside"
                          >
                            <svg
                              viewBox="0 0 16 16"
                              width="1em"
                              height="1em"
                              focusable="false"
                              role="img"
                              aria-label="calendar"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              className="bi-calendar b-icon bi"
                            >
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"></path>
                            </svg>
                          </button>
                        }
                      />
                      <label htmlFor="clickdatepic1" className="form-control">
                        {changeFilterFormatDate(date2)}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-5">
                  <div className="todate">
                    <label style={{ lineHeight: "41px" }}>To date:</label>
                    <div
                      className="b-form-btn-label-control dropdown b-form-datepicker form-control"
                      style={{
                        display: "flex",
                        alignItems: "stretch",
                        height: "auto",
                        padding: "0",
                        backgroundImage: "none",
                      }}
                    >
                      <DatePicker
                        id="clickdatepic"
                        selected={date1}
                        onChange={(date) => setdate1(date)}
                        dateFormat="yyyy-MM-dd"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        customInput={
                          <button
                            type="button"
                            className="btn h-auto react-datepicker-ignore-onclickoutside"
                          >
                            <svg
                              viewBox="0 0 16 16"
                              width="1em"
                              height="1em"
                              focusable="false"
                              role="img"
                              aria-label="calendar"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              className="bi-calendar b-icon bi"
                            >
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"></path>
                            </svg>
                          </button>
                        }
                      />
                      <label htmlFor="clickdatepic" className="form-control">
                        {changeFilterFormatDate(date1)}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-2">
                  <button
                    type="button"
                    className="btn btn-vaultex col-12 rounded-0 text-uppercase"
                    style={{
                      fontSize: "15.5px",
                      fontWeight: "500",
                      marginTop: "43px",
                    }}
                    onClick={searchDateWise}
                  >
                    Search
                  </button>
                </div>
              </div>

              <hr className="dashed" />

              {/* Payment Summary */}
              <div className="row datepicker">
                <div className="col-4">
                  <div className="fromdate" style={{ lineHeight: "31px" }}>
                    <label>Total Outstanding:</label>
                    <div>AED {allOutstandingInvoiceSum.toFixed(2)}</div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="todate" style={{ lineHeight: "31px" }}>
                    <label>Amount to be paid:</label>
                    <div>
                      <input
                        type="number"
                        value={inputValue}
                        readOnly
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <button
                    type="button"
                    className="btn btn-vaultex col-12 rounded-0 text-uppercase"
                    style={{ fontSize: "15.5px", fontWeight: "500" }}
                    onClick={handleMultipleInvoicePayment}
                  >
                    Make Payment
                  </button>
                </div>
              </div>

              <br />

              {/* Tabs */}
              <section id="tab-section" className="product-tab-sec">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <ul className="nav nav-tabs">
                        <li className="nav-item" style={{ fontSize: "18px" }}>
                          <button
                            type="button"
                            onClick={() => setTab("All Invoices")}
                            className={`nav-link ${
                              Tabcontent === "All Invoices" ? "active" : ""
                            }`}
                          >
                            All Invoices ({filteredData1.length})
                          </button>
                        </li>
                        <li className="nav-item" style={{ fontSize: "18px" }}>
                          <button
                            type="button"
                            onClick={() => setTab("Outstanding Invoices")}
                            className={`nav-link ${
                              Tabcontent === "Outstanding Invoices"
                                ? "active"
                                : ""
                            }`}
                          >
                            Outstanding Invoices ({filteredData2.length})
                          </button>
                        </li>
                      </ul>

                      {/* All Invoices Tab */}
                      {Tabcontent === "All Invoices" && (
                        <div className="tab-content">
                          <input
                            type="text"
                            placeholder="Search by Invoice Number..."
                            value={searchQuery1}
                            onChange={handleSearchInputChange1}
                            style={{
                              lineHeight: "35px",
                              padding: "3px",
                              margin: "10px",
                              width: "300px",
                            }}
                          />

                          {filteredData1.length === 0 ? (
                            <div
                              style={{ padding: "20px", textAlign: "center" }}
                            >
                              <p>
                                No invoices found for the selected date range.
                              </p>
                            </div>
                          ) : (
                            <>
                              <table className="table b-table calltable table-striped">
                                <thead>
                                  <tr>
                                    <th
                                      onClick={() => handleSort1("DocNum")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      Number{" "}
                                      {sortedField1 === "DocNum" &&
                                        (sortDirection1 === "asc" ? "↑" : "↓")}
                                    </th>
                                    <th
                                      onClick={() => handleSort1("DocDate")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      Date{" "}
                                      {sortedField1 === "DocDate" &&
                                        (sortDirection1 === "asc" ? "↑" : "↓")}
                                    </th>
                                    <th
                                      onClick={() => handleSort1("TransType")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      Type{" "}
                                      {sortedField1 === "TransType" &&
                                        (sortDirection1 === "asc" ? "↑" : "↓")}
                                    </th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>View</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {currentPageData1.map((invoice, index) => (
                                    <tr
                                      key={`all-${invoice.DocNum}-${index}`}
                                      style={{
                                        backgroundColor: invoice.isCredit
                                          ? "#fff3cd"
                                          : "transparent",
                                      }}
                                    >
                                      <td>{invoice.DocNum}</td>
                                      <td>
                                        {changeFormatDate(invoice.DocDate)}
                                      </td>
                                      <td>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color:
                                              invoice.TransType ===
                                              "A/R Invoice"
                                                ? "#0d6efd"
                                                : invoice.TransType ===
                                                    "Incoming Payment"
                                                  ? "#198754"
                                                  : "#dc3545",
                                          }}
                                        >
                                          {invoice.TransType}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          color: invoice.isCredit
                                            ? "#dc3545"
                                            : "#000",
                                          fontWeight: invoice.isCredit
                                            ? "bold"
                                            : "normal",
                                        }}
                                      >
                                        {invoice.isCredit ? "-" : ""}AED{" "}
                                        {invoice.Debit.toFixed(2)}
                                      </td>
                                      <td>
                                        <span
                                          style={{
                                            background:
                                              invoice.paymentStatus === "Paid"
                                                ? "#28a745"
                                                : invoice.paymentStatus ===
                                                    "Outstanding"
                                                  ? "#ffc107"
                                                  : "#dc3545",
                                            padding: "5px 15px",
                                            color: "white",
                                            borderRadius: "4px",
                                            fontSize: "13px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {invoice.paymentStatus}
                                        </span>
                                      </td>
                                      <td>
                                        <a
                                          href={`https://sbmmarketplace.com/backend/public/api/invoice_Test_PDF/${invoice.DocNum}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i
                                            className="fa fa-file-pdf-o fa-2x"
                                            style={{ color: "#007bff" }}
                                          ></i>
                                        </a>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                              <ul className="pagination">
                                <li>
                                  <a
                                    tabIndex="0"
                                    role="button"
                                    onClick={() =>
                                      currentPage1 > 1 &&
                                      setCurrentPage1(currentPage1 - 1)
                                    }
                                    style={{
                                      cursor:
                                        currentPage1 === 1
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity: currentPage1 === 1 ? 0.5 : 1,
                                    }}
                                  >
                                    Previous
                                  </a>
                                  <span style={{ margin: "0 15px" }}>
                                    Page {currentPage1} of {totalPages1 || 1}
                                  </span>
                                  <a
                                    tabIndex="0"
                                    role="button"
                                    onClick={() =>
                                      currentPage1 < totalPages1 &&
                                      setCurrentPage1(currentPage1 + 1)
                                    }
                                    style={{
                                      cursor:
                                        currentPage1 === totalPages1
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        currentPage1 === totalPages1 ? 0.5 : 1,
                                    }}
                                  >
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </>
                          )}
                        </div>
                      )}

                      {/* Outstanding Invoices Tab */}
                      {Tabcontent === "Outstanding Invoices" && (
                        <div className="tab-content">
                          <input
                            type="text"
                            placeholder="Search by Invoice Number..."
                            value={searchQuery2}
                            onChange={handleSearchInputChange2}
                            style={{
                              lineHeight: "35px",
                              padding: "3px",
                              margin: "10px",
                              width: "300px",
                            }}
                          />

                          {filteredData2.length === 0 ? (
                            <div
                              style={{ padding: "20px", textAlign: "center" }}
                            >
                              <p>No outstanding invoices found.</p>
                            </div>
                          ) : (
                            <>
                              <table className="table b-table calltable table-striped">
                                <thead>
                                  <tr>
                                    <th>
                                      <strong>Select All</strong>&nbsp;
                                      <input
                                        type="checkbox"
                                        onChange={handleSelectAllChange}
                                        checked={selectAll}
                                      />
                                    </th>
                                    <th
                                      onClick={() => handleSort2("DocNum")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      Number{" "}
                                      {sortedField2 === "DocNum" &&
                                        (sortDirection2 === "asc" ? "↑" : "↓")}
                                    </th>
                                    <th
                                      onClick={() => handleSort2("DocDate")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      Date{" "}
                                      {sortedField2 === "DocDate" &&
                                        (sortDirection2 === "asc" ? "↑" : "↓")}
                                    </th>
                                    <th>Due Date</th>
                                    <th>Days Until Due</th>
                                    <th>Total Amount</th>
                                    <th>View</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {currentPageData2.map((invoice, index) => (
                                    <tr
                                      key={`outstanding-${invoice.DocNum}-${index}`}
                                    >
                                      <td>
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            handleInvoiceCheckboxChange(
                                              invoice,
                                              e,
                                            )
                                          }
                                          checked={selectedInvoices.some(
                                            (inv) =>
                                              inv.DocNum === invoice.DocNum,
                                          )}
                                        />
                                      </td>
                                      <td>{invoice.DocNum}</td>
                                      <td>
                                        {changeFormatDate(invoice.DocDate)}
                                      </td>
                                      <td>
                                        {changeFormatDate(invoice.DueDate)}
                                      </td>
                                      <td>
                                        <span
                                          style={{
                                            color:
                                              invoice.DueDays < 0
                                                ? "#dc3545"
                                                : "#28a745",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {invoice.DueDays} days
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          color:
                                            invoice.Debit < 0
                                              ? "#dc3545"
                                              : "#000",
                                          fontWeight:
                                            invoice.Debit < 0
                                              ? "bold"
                                              : "normal",
                                        }}
                                      >
                                        {invoice.Debit < 0 ? "-" : ""}AED{" "}
                                        {Math.abs(invoice.Debit).toFixed(2)}
                                      </td>
                                      <td>
                                        <a
                                          href={`https://sbmmarketplace.com/backend/public/api/invoice_Test_PDF/${invoice.DocNum}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <i
                                            className="fa fa-file-pdf-o fa-2x"
                                            style={{ color: "#007bff" }}
                                          ></i>
                                        </a>
                                      </td>
                                      <td>
                                        {invoice.Debit > 0 ? (
                                          <a
                                            href="javascript:void(0);"
                                            className="makepayment"
                                            onClick={() =>
                                              handleSingleInvoicePayment(
                                                invoice,
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              color: "#ffffff",
                                              backgroundColor: "#0dcaf0",
                                              padding: "8px 20px",
                                              borderRadius: "4px",
                                              textDecoration: "none",
                                              display: "inline-block",
                                            }}
                                          >
                                            Payment
                                          </a>
                                        ) : (
                                          <span
                                            style={{
                                              color: "#6c757d",
                                              fontStyle: "italic",
                                              fontSize: "13px",
                                            }}
                                          >
                                            Credit applied
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                              <ul className="pagination">
                                <li>
                                  <a
                                    tabIndex="0"
                                    role="button"
                                    onClick={() =>
                                      currentPage2 > 1 &&
                                      setCurrentPage2(currentPage2 - 1)
                                    }
                                    style={{
                                      cursor:
                                        currentPage2 === 1
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity: currentPage2 === 1 ? 0.5 : 1,
                                    }}
                                  >
                                    Previous
                                  </a>
                                  <span style={{ margin: "0 15px" }}>
                                    Page {currentPage2} of {totalPages2 || 1}
                                  </span>
                                  <a
                                    tabIndex="0"
                                    role="button"
                                    onClick={() =>
                                      currentPage2 < totalPages2 &&
                                      setCurrentPage2(currentPage2 + 1)
                                    }
                                    style={{
                                      cursor:
                                        currentPage2 === totalPages2
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        currentPage2 === totalPages2 ? 0.5 : 1,
                                    }}
                                  >
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Invoice;
